<template>
  <div
    :class="['flex w-full items-center justify-center pb-2 box-border']"
    data-name="flight_search_step_list"
    :data-size="isDesktop ? 'medium' : 'small'"
  >
    <template v-for="(step, index) in steps">
      <div
        :key="index"
        class="flex shrink-0 items-center justify-center gap-1"
        data-name="flight_search_step"
        :data-size="isDesktop ? 'medium' : 'small'"
        :aria-current="index === currentStep ? 'step' : null"
      >
        <span
          :class="[
            'flex size-4 shrink-0 items-center justify-center rounded-full text-xs leading-4 text-white',
            index === currentStep
              ? 'bg-primary-500 font-bold'
              : 'bg-fig-gray-500 font-normal',
          ]"
          data-name="step_num"
          :data-state="index === currentStep ? 'current' : 'default'"
          >{{ index + 1 }}</span
        ><span
          :class="[
            'whitespace-nowrap',
            isDesktop ? 'text-base leading-5' : 'text-xs leading-4',
            index === currentStep
              ? 'font-bold text-ink'
              : 'font-normal text-fig-gray-500',
          ]"
          data-name="step_text"
          :data-state="index === currentStep ? 'current' : 'default'"
          >{{ step }}</span
        >
      </div>
      <span
        v-if="index < steps.length - 1"
        :key="`separator-${index}`"
        class="flex size-6 shrink-0 items-center justify-center"
        aria-hidden="true"
      >
        <i class="fa-solid fa-chevron-right text-xs text-ink" />
      </span>
    </template>
  </div>
</template>

<script>
const PC_STEPS = [
  'お客様情報入力',
  '入力内容の確認',
  '申込完了',
  '決済・予約完了',
];
const SP_STEPS = ['入力', '確認', '申込完了', '決済・予約完了'];

export default {
  props: {
    currentStep: {
      type: Number,
      required: true,
    },
  },
  computed: {
    steps() {
      return this.isDesktop ? PC_STEPS : SP_STEPS;
    },
  },
};
</script>
